import { Action, createAction, props } from '@ngrx/store';
import { ShowLoader, HideLoader } from '@app/shared/decorators';
import { AdvertisingMedia } from '@app/main/marketing-plans/models/advertising.model';

export const routeConfigStart = createAction('[App Page]  Route Config Start');

export const routeConfigEnd = createAction('[App Page]  Route Config Start End');
